<rt-box variant="with-border no-padding">
  <div layout-vertical layout-full-width>
    <div
      *ngIf="!marketplaceViewContext"
      layout-horizontal
      layout-align-items-center
      layout-full-width
      padding-medium
    >
      <div class="icon-box" layout-align-self-start>
        <ng-content select="[header-icon]"></ng-content>
      </div>

      <div margin-lr-medium>
        <div layout-horizontal layout-align-items-center>
          <rt-heading>
            {{ integrationName }}
          </rt-heading>

          <rt-badge
            *ngIf="isNew"
            color="primary-gradient"
            text="{{ 'rti.common.new' | translate }}"
            margin-left-small-x
          >
          </rt-badge>

          <rt-badge
            *ngIf="showIntegratedBadge"
            [color]="badge.color"
            [text]="badge.label"
            margin-left-small-x
          >
          </rt-badge>

          <rt-badge
            *ngIf="showPartnerNotPromotedBadge"
            color="optional"
            margin-left-small-x
            text="Promoted: false"
            rtTooltip="Integration available only to this company. Contact Recruitee to have it promoted globally."
          >
          </rt-badge>
        </div>

        <div>
          {{ settingsSubtitle }}

          <ng-content select="[integration-status-info]"></ng-content>
        </div>
      </div>

      <div margin-left-auto>
        <rt-button
          [loading]="integrateLoading"
          *ngIf="!integrated"
          (click)="integrate()"
          variant="outline"
        >
          {{ 'rti.common.settings.integrations.integrate_now' | translate }}
        </rt-button>

        <div *ngIf="integrated">
          <ng-container *ngIf="!editing">
            <rt-button
              *ngIf="manageIntegrationButton === 'integrate_now'"
              (click)="startEditing()"
              variant="outline"
            >
              {{ 'rti.common.settings.integrations.integrate_now' | translate }}
            </rt-button>

            <rt-button
              *ngIf="manageIntegrationButton === 'manage'"
              (click)="startEditing()"
              variant="plain"
            >
              <rt-icon name="edit"></rt-icon>
              <span>{{ 'rti.common.settings.integrations.manage' | translate }}</span>
            </rt-button>
          </ng-container>

          <rt-icon-button
            *ngIf="editing"
            (click)="stopEditing()"
            variant="plain"
            iconName="clear"
            shape="square"
          >
          </rt-icon-button>
        </div>
      </div>
    </div>

    <div
      *ngIf="(editing && integration) || (marketplaceViewContext && integration)"
      layout-vertical
    >
      <rt-divider variant="line" class="first-divider"></rt-divider>

      <div layout-vertical padding-medium>
        <ng-content select="[update-form-prelude]"></ng-content>

        <rti-role-ability-matrix
          *ngIf="showRoles"
          [roles]="companyRoles"
          [abilities]="abilities"
          [roleAbilityMap]="rolesForm"
          [disabled]="actionsDisabled"
          (roleAbilityMapUpdated)="updateRolesForm($event)"
        >
          <ng-container header>
            <rt-heading>
              {{ rolesTitle }}
            </rt-heading>
            <div>{{ rolesSubtitle }}</div>
          </ng-container>
        </rti-role-ability-matrix>

        <ng-content select="[update-form-postlude]"></ng-content>

        <rti-field-mapping-settings
          *ngIf="config!.fieldMapping"
          [config]="config!"
          [credentialize]="config!.credentialize"
        ></rti-field-mapping-settings>
      </div>

      <rt-divider variant="line"></rt-divider>

      <div layout-horizontal padding-medium>
        <ng-container footer *ngIf="integration">
          <div layout-horizontal layout-full-width layout-space-between>
            <div>
              <rt-button
                *ngIf="showRemoveIntegrationButton && !marketplaceViewContext"
                [disabled]="false"
                (click)="remove()"
                variant="plain"
                class="danger-on-hover"
              >
                <rt-icon name="remove-circle"></rt-icon>
                <span>{{ 'rti.common.settings.integrations.remove' | translate }}</span>
              </rt-button>
            </div>
            <div layout-horizontal>
              <rt-button
                *ngIf="!marketplaceViewContext"
                (click)="stopEditing()"
                variant="plain"
                margin-right-small
              >
                {{ 'rti.common.cancel' | translate }}
              </rt-button>
              <rt-button variant="primary" [disabled]="!canSave" [loading]="false" (click)="save()">
                {{ 'rti.common.save' | translate }}
              </rt-button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</rt-box>
